/**
 * Google Ads conversion tracking helpers.
 *
 * Central place for firing the Ads conversion label so we can swap labels later
 * (e.g. if you split Phone-Call vs Form-Lead into separate conversion actions).
 *
 * Current setup uses ONE label for both phone-click and form-submit conversions.
 */

const AW_ID = "AW-949948052";
const CONVERSION_LABEL = "j2ncCODl7bgBEJSd_MQD";

/**
 * Fire a Google Ads conversion event for a lead-form submission.
 * Called from EnquiryForm, DistributorsPage, CataloguePage on successful POST.
 */
export function trackFormLeadConversion({ formName = "enquiry_form" } = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "conversion", {
      send_to: `${AW_ID}/${CONVERSION_LABEL}`,
      event_category: "lead",
      event_label: formName,
      value: 1,
    });
  } catch (e) {
    // never break the UX because tracking failed
    console.warn("[ads] form conversion failed:", e);
  }
}

/**
 * Fire a Google Ads conversion event for a phone-CTA click on the SECONDARY number.
 * The primary number (9820596811) is tracked automatically via Google's
 * phone_conversion_number swap in index.html. This function only fires for
 * the number that isn't in the swap config.
 */
export function trackPhoneClickConversion({ number = "" } = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "conversion", {
      send_to: `${AW_ID}/${CONVERSION_LABEL}`,
      event_category: "phone_click",
      event_label: number,
      value: 1,
    });
  } catch (e) {
    console.warn("[ads] phone conversion failed:", e);
  }
}
